import requests from "./httpService";

const MenuServices = {
  addMenu: async (body) => {
    return requests.post(`/menu/add/`, body);
  },
  getAllMenu: async () => {
    return requests.get(`/menu/`);
  },
  getMenuById: async (id) => {

    return requests.get(`/menu/${id}`);
  },

  updateMenu: async (id, body) => {

    return requests.put(`/menu/update/${id}`, body);
  },

  deleteMenu: async (id) => {

    return requests.delete(`/menu/delete/${id}`);
  },
  updateActiveStatus: async (id, body) => {
    return requests.put(`/menu/active-inactive/${id}`, body);
  },
  getAllParent: async (type) => {
    return requests.get(`/menu/getAllParent/${type}`);
  },
  getAllSubParent: async (type, id_parent) => {

    return requests.get(`/menu/getAllParent/${type}/${id_parent}`);
  },
  getAllAdminMenu: async () => {
    return requests.get(`/menu/getAllAdminMenu`);
  },
};

export default MenuServices;
